<template>
	<Modal v-model="show" title="客户经理项目人部门成员信息" :width="60">
		<Spin v-if="$globalSpin" size="large" fix></Spin>
		<Form ref="modelForm" :model="modelForm" :rules="ruleValidate" label-position="top" class="small-form">
			<Row :gutter="16">
				<Col span="24">
				<FormItem label="说明">
					<span>公司名称手动填写，部门名称手动填写，成员下拉显示所有已审批通过的客户经理</span>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="16">
				<Col span="24">
				<FormItem label="公司名称" prop="projectCompany">
					<Input v-model="modelForm.projectCompany"></Input>
				</FormItem>
				</Col>
				<Col span="24">
				<FormItem label="部门名称" prop="projectName">
					<Input v-model="modelForm.projectName"></Input>
				</FormItem>
				</Col>
				<Col span="24">
				<FormItem label="选择成员" prop="projectCode">
					<Select v-model="modelForm.projectCode" filterable clearable>
						<Option v-for="item in memberList" :key="item.userName" :value="item.userName" :label="item.userPersonName">
						</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="24">
				<FormItem label="部门类型" prop="projectType">
					<Select v-model="modelForm.projectType">
						<Option value="市场部门">市场部门</Option>
						<Option value="非市场部门">非市场部门</Option>
					</Select>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<div slot="footer">
			<Button type="primary" @click="onSave">确认</Button>
			<Button type="error" @click="onCancel">取消</Button>
		</div>
	</Modal>
</template>

<script>
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';

import {
    getCustomerMgrCompanyList,
    getCustomerMgrDeptList,
    getCustomerMgrMemberList,
    addProject
} from '@/api/modules/account-management/inspector-user-management';

export default {
    name: 'RoleDeptCusMgrLeaderEdit',
    data() {
        return {
            show: false,
            uuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                projectCode: '',
                projectName: '',
                projectCompany: '',
                projectType: '',
                belongTo: '客户经理项目人'
            },
            ruleValidate: {
                projectCompany: [{
                    trigger: 'blur',
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value) {
                            callback();
                        }
                        else {
                            callback(new Error(' '));
                        }
                    }
                }],
                projectName: [{
                    trigger: 'blur',
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value) {
                            callback();
                        }
                        else {
                            callback(new Error(' '));
                        }
                    }
                }],
                projectCode: [{
                    trigger: 'blur',
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value) {
                            callback();
                        }
                        else {
                            callback(new Error(' '));
                        }
                    }
                }],
                projectType: [{
                    trigger: 'blur',
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value) {
                            callback();
                        }
                        else {
                            callback(new Error(' '));
                        }
                    }
                }]
            },
            companyList: [],
            deptList: [],
            memberList: []
        };
    },
    mounted() {},
    methods: {
        showModal(uuid) {
            if (uuid == '') {
                this.uuid = '';
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.uuid = uuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.getMemberList();
            this.$refs.modelForm.resetFields();
        },
        getMemberList() {
            getCustomerMgrMemberList().then(res => {
                if (res.code === 0) {
                    this.memberList = res.data.records;
                }
            });
        },
        onSave() {
            this.$refs.modelForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.modelForm);

                this.$showGlobalSpin();
                addProject(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped>
</style>
